import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { NextBtn, BackBtn } from 'components/Shared/Button';
import { useForm } from 'react-hook-form';
import useReferenceComponent from 'hooks/useReferenceComponent';
import ReferenceDocument from '../ReferenceDocument';
import { Row, Col, CardFooter, Form, Input, FormGroup, Label, FormFeedback } from 'reactstrap';
import { StepContainer } from './StepContainer';

const BlankStep = ({ handleBack, onComplete, showReference }) => {
    const { t } = useTranslation();
    const { register, handleSubmit, errors } = useForm({
        shouldFocusError: false,
    });
    const [reference, handleRefChange] = useReferenceComponent();
    const nextEnabled = true;
    const handleOnComplete = (data) => {
        if (reference.join && reference.documentMissing) {
            return;
        }
        onComplete(data, reference);
    };

    return (
        <StepContainer
            className="sidebar-new-contract-height"
            title={t('contracts.new.blank_document')}
            src={'/images/listing/createDocument/blanco.svg'}
            alt={t('contracts.new.source_template')}
            form={
                <Form onSubmit={handleOnComplete}>
                    <FormGroup>
                        <Label className="font-weight-bold">{t('contracts.new.name_title')}</Label>
                        <Input
                            invalid={!!errors.name}
                            name="name"
                            innerRef={register({ required: true })}
                            id="document-name-input"
                            placeholder={t('contracts.new.name_title')}
                        />
                        <FormFeedback invalid={errors.name}> {t('contracts.new.name_required')}</FormFeedback>
                        <ReferenceDocument onChange={handleRefChange} reference={reference} showReference={showReference} />
                    </FormGroup>
                </Form>
            }
            footer={
                <>
                    <BackBtn onClick={handleBack} label={t('form.exit')} />
                    <NextBtn onClick={handleSubmit(handleOnComplete)} isDisabled={!nextEnabled} label={t('contracts.listing.page_next')} />
                </>
            }
        />
    );
};

export default BlankStep;
